/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 修复会员等级数据,别乱点!别乱点!!
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/repair/level`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
